"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  '/': {
    title: 'Baş səhifə',
    lang: 'az',
    view: 'Home',
    "public": true,
    locales: {
      az: '/',
      en: '/en',
      ru: '/ru'
    }
  },
  //'/az': {ref: '/', lang: 'az', title: 'Baş səhifə'},
  '/en': {
    ref: '/',
    lang: 'en',
    title: 'Main page'
  },
  '/ru': {
    ref: '/',
    lang: 'ru',
    title: 'Главная страница'
  },
  '/notfound': {
    title: '404',
    view: 'NotFound',
    "public": true,
    locales: {
      az: '/az/notfound',
      en: '/en/notfound',
      ru: '/ru/notfound'
    }
  },
  '/az/notfound': {
    ref: '/notfound',
    lang: 'az',
    title: 'Səhifə tapılmadı'
  },
  '/en/notfound': {
    ref: '/notfound',
    lang: 'en',
    title: 'Page not found'
  },
  '/ru/notfound': {
    ref: '/notfound',
    lang: 'ru',
    title: 'Страница не найдена'
  },
  '/error': {
    title: 'Error page',
    view: 'Error',
    layout: 'Error',
    "public": true,
    locales: {}
  },
  '/soon': {
    title: 'Coming Soon',
    view: 'Soon',
    layout: 'Soon',
    "public": true,
    locales: {}
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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